import React from "react";

import "./styles/graphics.css"

function SeparatorGraphic() {
    return (
        <div className="separatorGraphic"></div>
    );
}

export default SeparatorGraphic;